import React from 'react';
import { TextCommon } from '../../UI/Text/TextCommon';
import styles from '../Calculator.module.css';

type TFeeBlockProps = {
    title?: string;
    text?: string;
    rate?: string;
    icon?: React.ReactNode;
};

const FeeBlock = React.memo(({ title, text, rate, icon }: TFeeBlockProps) => {
    return (
        <div className={styles.feePanelBlock}>
            <TextCommon
                isWidget={false}
                content={title}
                options={{
                    variant: 'secondary',
                    textColor: 'grey_72_lc',
                    textAlign: 'center',
                    margin: { bottom: 8 },
                }}
            />
            <div className={styles.feePanelBlockBottom}>
                <TextCommon
                    isWidget={false}
                    content={text}
                    options={{
                        variant: 'secondary',
                        textColor: 'black',
                        textAlign: 'center',
                        margin: { right: 3 },
                    }}
                />
                <TextCommon
                    isWidget={false}
                    content={rate?.toLowerCase()}
                    options={{
                        variant: 'secondary',
                        textColor: 'black',
                        textAlign: 'center',
                        smallCaps: true,
                    }}
                />
                {icon}
            </div>
        </div>
    );
});

export { FeeBlock };
